import { render, staticRenderFns } from "./list-research-site.vue?vue&type=template&id=5eb5ec48&scoped=true&"
import script from "./list-research-site.vue?vue&type=script&lang=js&"
export * from "./list-research-site.vue?vue&type=script&lang=js&"
import style0 from "./list-research-site.vue?vue&type=style&index=0&id=5eb5ec48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb5ec48",
  null
  
)

component.options.__file = "list-research-site.vue"
export default component.exports